import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Client, ClientService} from '@app/admin/client.service';
import {InvitationLinkDialogComponent} from '@app/invitation/invitation-link-dialog/invitation-link-dialog.component';
import {InvitationService} from '@app/invitation/invitation.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-invitation-link',
    imports: [AsyncPipe],
    templateUrl: './invitation-link.component.html',
    styleUrl: './invitation-link.component.scss',
})
export class InvitationLinkComponent implements OnInit {
    public client$: Observable<Client>;

    constructor(
        private clientService: ClientService,
        private invitationService: InvitationService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.client$ = this.clientService.client;
    }

    getInvitationLink(client: Client): void {
        this.invitationService.getInvitationLink(client.id).subscribe((result: any) => {
            if (result.errors.count > 0) {
                return;
            }

            this.matDialog.open(InvitationLinkDialogComponent, {
                width: '600px',
                data: result.url,
            });
        });
    }
}
